import React from "react";
import "./table.scss";
const TableRow = ({ data }) => {
    return (
        <tr>
            {data.map((item,index) => {
                return <td key={index} className={`${typeof item === 'number' ? 'rightalinged' : ''}`}>{item}</td>;
                
            })}
        </tr>
    );
};

export default TableRow;